import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { TextFields, AutoCompletes } from "../../utils/commonComponent/Custom/custominput";
import { ModalButton } from "../../utils/commonComponent/Custom/Button";
import { fetchEmployeeTechnicalManager } from "./fetchHandler";

const fields = [
  { 
    key: "conformityStatement", 
    label: "Conformity Statement",
    type: "select",
    options: ["Yes", "No","Not-Applicable"]
  },
  { 
    key: "remarks", 
    label: "Remarks",
    type: "text",
    multiline: true
  },
  { 
    key: "sampleAdequacy", 
    label: "Sample Adequacy",
    type: "select",
    options: ["Yes", "No","Not-Applicable"]
  },
  { 
    key: "nablScope", 
    label: "NABL Scope",
    type: "select",
    options: ["Yes", "No","Not-Applicable"]
  },
  { 
    key: "testPersonstatus", 
    label: "Test Person Status",
    type: "select",
    options: ["Yes", "No","Not-Applicable"]
  },
  { 
    key: "sourceAdequacy", 
    label: "Source Adequacy",
    type: "select",
    options: ["Yes", "No","Not-Applicable"]
  },
  { 
    key: "weatherLab", 
    label: "Whether the lab has understood the requirements of the Customer",
    type: "select",
    options: ["Yes", "No","Not-Applicable"]
  },
  { 
    key: "sampleCondition", 
    label: "Sample Condition",
    type: "select",
    options: ["Satisfactory", "Unsatisfactory", "Not-Applicable"]
  },
  { 
    key: "customerRequirement", 
    label: "Customer Requirement",
    type: "text",
    multiline: true
  },
  {
    key: "retentionperiod",
    label: "Extra Retention Period Required",
    type: "select",
    options: ["Yes", "No"]
  }
];
const monthOptions = Array.from({ length: 12 }, (_, i) => (i + 1).toString());

export default function OfficeModal({ formData, handleChange }) {
  const [technicalManagerList, setTechnicalManagerList] = useState([]);
  useEffect(() => {
    fetchEmployeeTechnicalManager(setTechnicalManagerList);
  }, []);

  return (
    <>
      <ModalButton
        buttonLabel="For office Details only"
        modalTitle="Office Details"
      >
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {fields.map((field) => (
            field.type === "select" ? (
              <AutoCompletes
                key={field.key}
                label={field.label}
                value={formData?.[field?.key] || null}
                onChange={(value) => handleChange(field.key, value)}
                options={field.options}
                size="small"
                fullWidth
              />
            ) : (
              <TextFields
                key={field.key}
                label={field.label}
                value={formData[field.key] || ""}
                onChange={(e) => handleChange(field.key, e.target.value)}
                multiline={field.multiline || false}
                minRows={field.multiline ? 3 : 1}
              />
            )
          ))}

          {/* Conditionally render month dropdown if retentionperiod === "Yes" */}
         {formData.retentionperiod === "Yes" && (
           <AutoCompletes
             key="retentionFrequency"
             label="Select Retention Period (in months)"
             value={formData.retentionFrequency || null}
             onChange={(value) => handleChange("retentionFrequency", value)}
             options={monthOptions}
             size="small"
             fullWidth
           />
         )}
         
          {/* NEW FIELD: Technical Manager */}
          <AutoCompletes
            label="Technical Manager"
            value={formData?.technicalManager || null}
            onChange={(value) => handleChange("technicalManager", value)}
            options={technicalManagerList}
            labelKey="employeeName"
            valueKey="id"
            getOptionLabel={(option) =>
              option
                ? `${option.employeeName} (${option.userName})`
                : ""
            }
            size="small"
            fullWidth
          />
        </Box>
      </ModalButton>
    </>
  );
}